import * as React from "react";
const SvgEllipse15 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 5, viewBox: "0 0 5 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 15", cx: 2.5, cy: 2.5, r: 2.5, fill: "#87878D" }));
export default SvgEllipse15;
